module.exports = __webpack_public_path__ + "static/media/36x181.e5cecb33.png";